<div
  [class.conv-container]="conversationBegan"
  [class.dashboard-landing]="!conversationBegan"
  [class.dashboard-landing--top-anchored]="!conversationBegan && isBotUiConfigEnabled"
>
  @if (!conversationBegan) {
    <div class="centered-content landing-hero-fade">
      @if (isLogoVisible) {
        <img [appImgFallback]="fallbackLogo" [src]="dashboardLogo" alt="OneRay logo" class="logo" />
      }
      <h1 class="greeting-text">{{ displayedGreeting }}</h1>
      @if (isValidatorEnabled && !isChatVisible) {
        <section class="validator-upload-card" aria-labelledby="validator-upload-title">
          <div class="validator-upload-card__message">
            <div class="validator-upload-card__copy">
              <span class="validator-upload-card__label">ValidAItor</span>
              <p id="validator-upload-title">
                <span class="validator-upload-card__title">Upload for validation</span>
                <span class="validator-upload-card__hint">Pick a folder, then run validation.</span>
              </p>
            </div>
            <button
              type="button"
              class="validator-upload-card__upload-btn"
              aria-label="Choose files to upload for validation"
              (click)="openValidatorUploadPicker(validatorDashboardUploadInput)"
            >
              <mat-icon aria-hidden="true">attach_file</mat-icon>
            </button>
          </div>
          <input
            #validatorDashboardUploadInput
            type="file"
            class="validator-upload-card__input"
            multiple
            accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
            (change)="openValidatorUploadWizard($event)"
          />
        </section>
      }
    </div>
  }

  <!-- Agent selector shown when feature flag is enabled and conversation hasn't started -->
  @if (!conversationBegan && isBotUiConfigEnabled) {
    <div class="bot-selector-wrapper">
      <app-agent-selector
        [selectedBotId]="selectedBot?._id || null"
        (botSelected)="onBotSelected($event)"
      ></app-agent-selector>
      @if (!selectedBot) {
        <p class="bot-selector-message">
          How may I help you today? Please select the button closest to the action you would like to
          take.
        </p>
      }
    </div>
  }

  @if (selectedBot || conversationBegan || !isBotUiConfigEnabled) {
    <app-agent-conversation
      [conversationInputExtended]="!conversationBegan"
      [filtersButtonEnabled]="true"
      [talkingWith]="selectedBot"
      [shouldShowWelcome]="conversationBegan || !selectedBot"
      [hideWelcomeOnChatFeature]="true"
      [uiConfiguration]="isBotUiConfigEnabled ? selectedBot?.uiConfiguration : undefined"
      [initialMessage]="pendingSuggestion"
    >
      <div header><app-talking-avatar [agent]="null"></app-talking-avatar></div>
      @if (isValidatorEnabled && !conversationBegan) {
        <section
          belowInput
          class="validator-upload-card validator-upload-card--attached"
          aria-labelledby="validator-upload-title-chat"
        >
          <div class="validator-upload-card__message">
            <div class="validator-upload-card__copy">
              <span class="validator-upload-card__label">ValidAItor</span>
              <p id="validator-upload-title-chat">
                <span class="validator-upload-card__title">Upload for validation</span>
                <span class="validator-upload-card__hint">Pick a folder, then run validation.</span>
              </p>
            </div>
            <button
              type="button"
              class="validator-upload-card__upload-btn"
              aria-label="Choose files to upload for validation"
              (click)="openValidatorUploadPicker(validatorDashboardUploadInput)"
            >
              <mat-icon aria-hidden="true">attach_file</mat-icon>
            </button>
          </div>
          <input
            #validatorDashboardUploadInput
            type="file"
            class="validator-upload-card__input"
            multiple
            accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
            (change)="openValidatorUploadWizard($event)"
          />
        </section>
      }
    </app-agent-conversation>
  }


</div>

@if (dashboardContent) {
  <div class="info-corner">
    <button
      class="info-trigger"
      type="button"
      aria-label="About this environment"
      (click)="infoOpen = !infoOpen"
    >
      <span class="material-icons">info_outline</span>
    </button>

    @if (infoOpen) {
      <div class="info-panel" role="dialog" aria-modal="true" aria-label="About this environment">
        <div class="info-panel__header">
          <span class="info-panel__title">About this environment</span>
          <button class="info-panel__close" type="button" aria-label="Close" (click)="infoOpen = false">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="info-panel__body" [innerHTML]="dashboardContent"></div>
      </div>

      <div class="info-backdrop" (click)="infoOpen = false"></div>
    }
  </div>
}
